import type { CuratedStory, Image } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
    INTEGRITY_FAIL_MEDIA,
    firstItemOnly,
} from "~utils/moduleIntegrity";

interface SingleStoryPremiumHfsIntegrityProps {
    items?: CuratedStory[];
    image?: Image;
    embedUrl?: string;
    liveStream?: string;
}

export default function integrityCheck({
    items = [],
    image,
    embedUrl,
    liveStream,
}: SingleStoryPremiumHfsIntegrityProps): IntegrityStatus {
    const messages = checkItemArrayIntegrity(firstItemOnly(items));

    // This variation needs some form of multimedia to be valid.
    if (
        !(
            embedUrl ||
            liveStream ||
            image?.baseUrl ||
            (items?.length && items[0].image?.baseUrl)
        )
    ) {
        messages.push(INTEGRITY_FAIL_MEDIA);
    }

    return messages;
}
